import React, { useMemo, type FC } from 'react'

import styled from '@emotion/styled'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { FormElement, Select } from 'mailup-web-components'

import type { ColumnName } from 'Pages/RecipientsList/model'
import { modalBulkFindReplaceChangeFieldCallback } from 'Pages/RecipientsList/recoil/callbacks/modalBulkFindReplace'
import { getColumnName } from 'Pages/RecipientsList/recoil/services/results'
import { dynamicFieldsState } from 'Pages/RecipientsList/recoil/state/columns'
import { modalBulkFindReplaceState } from 'Pages/RecipientsList/recoil/state/modalBulkFindReplace'

const StyledSelect = styled(Select)`
  .e-select__tray {
    max-height: 185px;
  }
`

const InputField: FC = () => {
  const intl = useIntl()

  const { FindColumn, previewStatus } = useRecoilValue(
    modalBulkFindReplaceState,
  )

  const dynamicFields = useRecoilValue(dynamicFieldsState)

  const changeField = useRecoilCallback(
    modalBulkFindReplaceChangeFieldCallback,
    [],
  )

  const options = useMemo(() => {
    const columns: ColumnName[] = [
      'Email',
      'MobilePrefix',
      'MobileNumber',
      ...dynamicFields.map((df) => `Field${df.id}` as ColumnName),
    ]

    return columns.map((c) => ({
      value: c,
      label: getColumnName(c, dynamicFields),
    }))
  }, [dynamicFields])

  const handleChange = (v: ColumnName): void => {
    void changeField('FindColumn', v)
  }

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.RecipientsList.ModalBulkFindReplaceFind',
      })}
    >
      <StyledSelect
        data-mu-test="find-replace-input-find-column"
        value={FindColumn}
        options={options}
        onChange={handleChange}
        placeholder={intl.formatMessage({
          id: 'Load.RecipientsList.ModalBulkFindReplaceFieldPlaceholder',
        })}
        disabled={previewStatus === 'fetching'}
      />
    </FormElement>
  )
}

export default InputField
